import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import { useTranslation } from 'react-i18next'
import { userLocationIcon, createCategoryMarkerIcon } from './icons'
import { RecenterMap } from './RecenterMap'
import { MerchantPopup } from './MerchantPopup'

interface MerchantsMapProps {
  center: [number, number]
  zoom: number
  userLocation: { lat: number; lng: number } | null
  merchants: any[]
  onImageClick: (imageUrl: string) => void
  onReviewsClick: (merchant: any) => void
  onRatingClick: (merchant: any) => void
}

export function MerchantsMap({
  center,
  zoom,
  userLocation,
  merchants,
  onImageClick,
  onReviewsClick,
  onRatingClick,
}: MerchantsMapProps) {
  const { t } = useTranslation()
  const RLMap = MapContainer as unknown as any

  return (
    <div className="merchants-map-container">
      <RLMap
        center={center}
        zoom={zoom}
        scrollWheelZoom
        className="h-full w-full"
      >
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <RecenterMap center={center} zoom={zoom} />

        {userLocation && (
          <Marker 
            position={[userLocation.lat, userLocation.lng]}
            {...({ icon: userLocationIcon } as any)}
          >
            <Popup>
              <div className="text-center">
                <div className="font-semibold text-blue-600">{t('merchants.youAreHere')}</div>
              </div>
            </Popup>
          </Marker>
        )}

        {merchants && merchants.map((m: any) => {
          const lat = typeof m.latitude === 'string' ? parseFloat(m.latitude) : m.latitude
          const lng = typeof m.longitude === 'string' ? parseFloat(m.longitude) : m.longitude
          if (isNaN(lat) || isNaN(lng)) return null
          const customIcon = m.category ? createCategoryMarkerIcon(m.category) : undefined
          return (
            <Marker 
              key={m.id} 
              position={[lat, lng]}
              {...(customIcon ? { icon: customIcon } as any : {})}
            >
              <Popup>
                <MerchantPopup
                  merchant={m}
                  onImageClick={onImageClick}
                  onReviewsClick={() => onReviewsClick(m)}
                  onRatingClick={() => onRatingClick(m)}
                />
              </Popup>
            </Marker>
          )
        })}
      </RLMap>
    </div>
  )
}



